import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {DropdownMenu} from '../../../content/types/dropdown-menu.types'
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown'

@Component({
  selector: 'bgo-more-dropdown',
  templateUrl: './more-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {ngSkipHydration: 'true'}, //eslint-disable-line @angular-eslint/no-host-metadata-property
  styles: [
    `
      :host {
        @apply text-president-100;
      }
      :host-context(.layout-navbar--transparent:not(.layout-navbar--scrolled)) {
        @apply text-grey-0;
      }
    `,
  ],
})
export class MoreDropdownComponent {
  protected readonly dropdownIcon = faCaretDown

  @Input()
  public menu!: DropdownMenu
}
